import { useNavigate } from "react-router-dom";

const NotFoundComp = () => {
    const navigate = useNavigate();
    
    const goToHome = () => {
        navigate('/');
    }
    return (
        <div className="h-screen w-screen flex justify-center items-center bg-gradient-to-b from-slate-950 via-fuchsia-950 to-gray-950">
            <div className="h-full flex flex-col justify-center">
                <h1 className="text-5xl mt-0 mb-5">Oops!</h1>
                <p className="text-lg text-gray-300">404 - Page Not Found</p>
                <p className="text-gray-400 mb-8">The page you are looking for might have been removed, had its name changed or is temporarily unavailable.</p>
                {/* <button 
                    onClick={goToHome}
                    className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-8 py-4 rounded-full text-sm font-medium hover:opacity-90 transition-opacity w-full"
                >
                    Go Back to Home
                </button> */}
            </div>
        </div>
    );
}

export default NotFoundComp